import React, { useEffect, useRef, useState } from 'react'
import { adminSetPortfolioFees } from '../SA_UserPortfolios/actions';

const Label = ({ value, unit }) => {
    return (
        <div style={{ paddingLeft: '8px' }}>
            {unit === '$' && <div>{unit}{value}</div>}
            {unit === 'bp' && <div>{value} {unit}</div>}
        </div>
    )
}

const RenderInput = ({ value, component, token, accountIndex, username, columnLabel, columnName, unit, isEditButton }) => {
    const [isEdit, setIsEdit] = useState(false);
    const [inputValue, setInputValue] = useState(value);
    const [errorMessage, setErrorMessage] = useState('');
    const ref = useRef(null);

    useEffect(() => {
        setInputValue(value);
    }, [value])

    useEffect(() => {
        if(ref.current) {
            ref.current.focus();
        }
    }, [isEdit])

    const reset = () => {
        setInputValue(value);
        setIsEdit(false)
    }

    const handleOnClick = (e) => {
        if(e.ctrlKey || e.metaKey || !isEditButton) {
            return;
        }

        setIsEdit(true);
    }

    const handleOnChange = (e) => {
        e.preventDefault();
        const value = e.target.value
        const regex = /^\d+\.?\d*$/;
        
        if(value !== '' && !regex.test(value)) {
            return;
        }

        setInputValue(value);
    }

    const handleSubmit = async () => {
        if(!inputValue) {
            setErrorMessage(`${columnLabel} cannot be empty!`)
            return;
        }

        try {
            const unitSymbol = unit === '$' ? 'dollar' : 'basisPoint';
            const fees = { [columnName]: Number(inputValue), unit: unitSymbol }
            const response = await adminSetPortfolioFees(token, accountIndex, username, fees);
            if(response.status !== 'OK') {
                throw new Error(response);
            }
        } catch (error) {
            console.log(JSON.stringify(error, null, 2));
        } finally {
            setIsEdit(false);
            component.maybeLoad(true);
        }
    }

    const handleOnKeyDown = async (e) => {
        // if one more key, use switch
        if(e.key === "Enter") {
            await handleSubmit();
        } else if (e.key === "Escape") {
            reset();
        }
    }

    const handleOnBlur = () => {
        reset();
    }


    return (
        <React.Fragment>
            {!isEdit && 
                <div onClick={handleOnClick}>
                    <Label value={inputValue} unit={unit} />
                </div>
            }

            {isEdit && isEditButton &&
                <div>
                    <input ref={ref} type="text" value={inputValue} onChange={handleOnChange} onKeyDown={handleOnKeyDown} onBlur={handleOnBlur}/>
                    <p>{errorMessage}</p>
                </div>
            }
        </React.Fragment>
    )
}

export default RenderInput